<template lang="pug">
  div
    template(v-if="Object.keys(nonEmptyRows).length && (model && Object.keys(model).length)")
     div(v-for="row in nonEmptyRows").tooltip__body-item
      span.info.info--grey {{row.label}}:
      span(v-html="model[row.value]").info
    template(v-else)
      span Нет данных
</template>
<script>
  export default {
    name: 'popup-fields-rows',
    computed: {
      nonEmptyRows() {
        function filterEmpty(rows, model) {
          return rows.filter(({label, value }) => {
            return model[value] && model[value] !== '-' &&
              model[value] !== null &&
              model[value] !== '' &&
              parseFloat(model[value]) !== 0
          })
        }
        if (Array.isArray(this.rows) && this.rows?.length) {
          return filterEmpty(this.rows, this.model)
        }
        if (typeof this.rows === 'object') {
          const rows = Object.values(this.rows);
          if (!rows?.length) {
            return {}
          }
          const rowsObj = {}
          filterEmpty(rows, this.model).map(row => { rowsObj[row.value] = row })
          return rowsObj
        }
      }
    },
    props: {
      rows: [Array, Object],
      model: Object
    },
    methods: {
      calcValue(row) {
        if (!this.model[row.value] || this.model[row.value] === "0") {
          return " - "
        } else {
          return this.model[row.value]
        }
      }
    }
  }
</script>
